const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "vault_sid";
const OPT_OUT_KEY = "vault_no_track";

const deviceType = () => {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
};

const sessionId = () => {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

const INTERNAL_REF = /emergent|e1\.app|localhost|127\.0\.0\.1/i;

const optedOut = () => {
  if (window.top !== window.self) return true;
  if (INTERNAL_REF.test(document.referrer || "")) return true;
  if (localStorage.getItem(OPT_OUT_KEY) === "1") return true;
  if (new URLSearchParams(window.location.search).get("nt") === "1") {
    localStorage.setItem(OPT_OUT_KEY, "1");
    return true;
  }
  return localStorage.getItem("vault_admin_token") !== null;
};

const started = Date.now();
let firstReferrer = "";

const send = (body, beacon = false) => {
  if (optedOut()) return;
  const payload = JSON.stringify({
    session_id: sessionId(),
    device: deviceType(),
    host: window.location.hostname,
    referrer: body.referrer ?? firstReferrer,
    ...body,
  });
  const url = `${API}/track`;
  if (beacon && navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    return;
  }
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    keepalive: true,
  }).catch(() => {});
};

export const trackPageview = (path) => {
  if (!firstReferrer) {
    firstReferrer = document.referrer || "";
  }
  const params = new URLSearchParams(window.location.search);
  send({
    type: "pageview",
    path,
    source: params.get("utm_source") || "",
  });
};

export const trackEvent = (name, label) =>
  send({ type: "event", name, label, path: window.location.pathname });

export const initSessionEnd = () => {
  const close = () => {
    send(
      {
        type: "session_end",
        path: window.location.pathname,
        duration: Math.round((Date.now() - started) / 1000),
      },
      true,
    );
  };
  window.addEventListener("pagehide", close);
  return () => window.removeEventListener("pagehide", close);
};
